/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */
export const elementAdapterNativeDataKey = 'application/vnd.pdnd';